module.exports = __webpack_public_path__ + "static/img/banner-cursos-home-500x750.2d9ab9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-cursos-home-500x750.jpg
// module id = iXar
// module chunks = 47